import React from 'react';
export function Footer() {
  return <footer className="bg-riskeys-dark text-white py-20 relative overflow-hidden" data-id="element-121">
      {/* Background pattern */}
      <div className="absolute inset-0 z-0 opacity-5" data-id="element-122">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-123">
          <pattern id="footer-grid" width="10" height="10" patternUnits="userSpaceOnUse" patternContentUnits="userSpaceOnUse" data-id="element-124">
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5" data-id="element-125" />
          </pattern>
          <rect x="0" y="0" width="100%" height="100%" fill="url(#footer-grid)" data-id="element-126"></rect>
        </svg>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-127">
        <div className="grid md:grid-cols-4 gap-12" data-id="element-128">
          <div data-id="element-129">
            <div className="flex items-center mb-6" data-id="element-130">
              <a href="/" aria-label="Retour à l'accueil" className="flex items-center" data-id="element-131">
                <div className="bg-white p-2 rounded-md shadow-md mr-3" data-id="element-132">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6hFeyx2cfKZZEniYCGUcu3/RISKEYS-8-150x150.png" alt="Riskeys Logo" className="h-10 w-auto" data-id="element-133" />
                </div>
                <span className="font-bold text-xl text-white" data-id="element-134">RISKEYS</span>
              </a>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-135">
              Votre partenaire stratégique en conseil et audit en assurance.
            </p>
            <div className="flex space-x-5" data-id="element-136">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-riskeys-accent-light hover:bg-riskeys-accent-default hover:text-white transition-all duration-300" data-id="element-137">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-138">
                  <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" data-id="element-139" />
                </svg>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-riskeys-accent-light hover:bg-riskeys-accent-default hover:text-white transition-all duration-300" data-id="element-140">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-141">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-142" />
                </svg>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-riskeys-accent-light hover:bg-riskeys-accent-default hover:text-white transition-all duration-300" data-id="element-143">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-144">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" data-id="element-145" />
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-146">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-147">
              Liens Rapides
            </h4>
            <ul className="space-y-4 text-white/70" data-id="element-148">
              <li data-id="element-149">
                <a href="#qui-sommes-nous" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-150">
                  <span className="mr-2" data-id="element-151">→</span>
                  Qui sommes-nous
                </a>
              </li>
              <li data-id="element-152">
                <a href="#domaines-interventions" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-153">
                  <span className="mr-2" data-id="element-154">→</span>
                  Nos domaines d'interventions
                </a>
              </li>
              <li data-id="element-155">
                <a href="#success-stories" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-156">
                  <span className="mr-2" data-id="element-157">→</span>
                  Ils nous font confiance
                </a>
              </li>
              <li data-id="element-158">
                <a href="#faq" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-159">
                  <span className="mr-2" data-id="element-160">→</span>
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-161">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-162">
              Nos domaines d'interventions
            </h4>
            <ul className="space-y-4 text-white/70" data-id="element-163">
              <li data-id="element-164">
                <a href="#domaines-interventions" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-165">
                  <span className="mr-2" data-id="element-166">→</span>
                  Optimisation Assurance
                </a>
              </li>
              <li data-id="element-167">
                <a href="#domaines-interventions" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-168">
                  <span className="mr-2" data-id="element-169">→</span>
                  Assurances IARD
                </a>
              </li>
              <li data-id="element-170">
                <a href="#domaines-interventions" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-171">
                  <span className="mr-2" data-id="element-172">→</span>
                  Assurances de Personnes
                </a>
              </li>
              <li data-id="element-173">
                <a href="#contact" className="hover:text-riskeys-accent-light transition-colors inline-flex items-center" data-id="element-174">
                  <span className="mr-2" data-id="element-175">→</span>
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-176">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-177">Contact</h4>
            <ul className="space-y-5 text-white/70" data-id="element-178">
              <li className="flex items-start" data-id="element-179">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-180">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-181">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-182" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-183" />
                  </svg>
                </div>
                <span data-id="element-184">
                  108 BOULEVARD CHARLES DE GAULLE
                  <br data-id="element-185" />
                  92700 COLOMBES
                </span>
              </li>
              <li className="flex items-center" data-id="element-186">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-187">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-188">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-189" />
                  </svg>
                </div>
                <span data-id="element-190">0033 6 67 64 74 25</span>
              </li>
              <li className="flex items-center" data-id="element-191">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-192">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-193">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-194" />
                  </svg>
                </div>
                <span data-id="element-195">consulting@riskeys.fr</span>
              </li>
              <li className="flex items-center" data-id="element-196">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-197">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-198">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-199" />
                  </svg>
                </div>
                <span data-id="element-200">Lundi – Vendredi : 8h00 – 17h00</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-16 pt-8 text-center text-white/50 text-sm" data-id="element-201">
          <p data-id="element-202">
            &copy; {new Date().getFullYear()} RISKEYS. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>;
}